import { ChangeDetectionStrategy, Component, HostBinding, inject, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBar, matSnackBarAnimations, MatSnackBarRef } from '@angular/material/snack-bar';
import { Store } from "@ngrx/store";
import { AuthState } from "../../store/reducers/auth.reducer";
import { Router } from "@angular/router";
import { MatIcon } from '@angular/material/icon';

/**
 * Affiche d'une snack bar d'erreur
 * TODO il faudrait sûrement le migrer dans le thème
 */

@Component({
    selector: 'lib-snack-error',
    templateUrl: './snack-error.component.html',
    styleUrls: ['./snack-error.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [matSnackBarAnimations.snackBarState],
    imports: [MatIcon],
})
export class SnackErrorComponent {

  snackBarRef = inject( MatSnackBarRef<SnackErrorComponent>);
  data = inject(MAT_SNACK_BAR_DATA);

  @HostBinding('class') hostClass = 'mat-simple-snackbar';

  public static open(snackBar: MatSnackBar, error: Error, icon = 'warning') {
    snackBar.openFromComponent(
      SnackErrorComponent,
      {
          data: { matIcon: icon, error: error },
          announcementMessage: error.message,
          duration: 2500,
          panelClass: 'error',
          verticalPosition: 'top',
      }
  );
}

}
